import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.section`
  gap: 10px;
  display: flex;
  flex-direction: column;
`

export const BorderContainer = styled.section`
  position: relative;
  transition: background-color 0.3s ease-in-out;

  &.-is-dragging-over {
    background-color: var(--clvn-blue-50);
  }

  svg.dashed-border-svg {
    z-index: 1;
  }

  svg.dashed-border-svg rect {
    stroke: var(--clvn-blue-400);
  }
`

export const DropFile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  position: relative;
  z-index: 2;
`

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
  text-align: center;
  color: var(--clvn-blue-800);
  margin: 0;
`

export const Description = styled.h1`
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  line-height: 1.45;
  color: var(--clvn-blue-800);
  margin: 0;
`

export const Status = styled.h1`
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  line-height: 1.45;
  color: var(--clvn-blue-800);
  margin: 0;

  .-is-error {
    color: var(--clvn-red-300);
    font-weight: bold;
    margin-left: 5px;
  }

  .-in-progress {
    color: #0091ff;
    font-weight: bold;
    margin-left: 5px;
  }
`

export const uploadButtonCSS = css`
  width: 100%;
  background-color: var(--clvn-blue-600);
  border: 1px solid var(--clvn-blue-600);
  color: #fff;

  &:hover {
    background-color: var(--clvn-blue-600);
    border: 1px solid var(--clvn-blue-600);
  }
`

export const uploadButtonActiveCSS = css`
  width: 100%;
  background-color: var(--clvn-blue-200);
  color: var(--clvn-blue-600);
  border: 1px solid #abc0c8;

  &:hover {
    background-color: var(--clvn-blue-200);
    border: 1px solid #abc0c8;
  }
`
